/* default style for component */
export const style = {
  mobileViewBox: {
    display: {
      xs: "block",
      sm: "block",
      md: "none",
    },
  },

  appBarHeader: {
    background: "white",
    position: "fixed",
    zIndex: 10,
    top: 0,
    left: 0,
    height: {
      xs: "8vh",
    },
  },

  menuIcon: {
    color: "#020067",
    height: "10vh",
    maxWidth: {
      xs: "7.5vw",
      sm: "7vw",
    },
  },

  mainBox: {
    background:
      "linear-gradient(122deg, rgba(208,212,220,1) 30%, rgba(250,198,147,1) 85%, rgba(220,154,129,1) 98%)",
    height: { xs: "auto", sm: "auto", md: "100vh" },
  },

  childBox: {
    display: { xs: "grid", sm: "grid", md: "grid" },
    gridTemplateColumns: { xs: "1fr", sm: "1fr", md: "25% 1fr" },
    gap: { xs: "0", md: "56px" },
    padding: { xs: "40px 9px", md: "56px" },
    // marginTop: {md: "0%"}
  },

  leftDrawer: {
    "& .MuiDrawer-paper": {
      width: {
        xs: "300px",
        sm: "400px",
      },
    },
    overflowX: { xs: "hidden", sm: "hidden" },
    maxWidth: {
      xs: "80vw",
    },
  },

  letfBox: {
    p: 2,
    width: { md: "60vw" },
    backgroundColor: { xs: "none", sm: "none", md: "#F7FAFF" },
    overflowX: "hidden",
  },

  webBox: {
    padding: "30px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    borderRadius: "22px",
    opacity: 1,
    backdropFilter: "blur(30px)",
    webkitBackdropFilter: "blur(30px)",
    display: {
      xs: "none",
      sm: "none",
      md: "block",
    },
  },

  rightPart: {
    display: " grid",
    alignItems: { md: "end" },
  },

  chatBox: {
    height: { xs: "59vh", sm: "76vh", md: "79vh" },
    overflowY: "auto",
    paddingTop: { xs: "2rem" },
    "::-webkit-scrollbar": {
      display: "none",
    },
  },

  chatKonvergeLogo: {
    display: "block",
    margin: "auto",
    width: { xs: "46%", sm: "47%", md: "80%" },
  },

  userHeader: {
    display: "block",
    margin: "auto",
    width: "80%",
    marginTop: "10%",
  },

  leftText: {
    textAlign: { xs: "center", sm: "center", md: "center" },
    fontSize: { xs: "15px", md: "18px" },
    fontWeight: 600,
    fontFamily: "Quicksand",
    letterSpacing: "0px",
    color: "#393939",
    opacity: 1,
    padding: { xs: "20px", sm: "40px", md: "42px" },
  },

  closeIconBtn: {
    cursor: "pointer",
    background: "#FD7E00",
    color: "white",
    float: "right",
    mt: {
      xs: "5px",
    },
    mr: {
      xs: "3px",
      sm: "0px",
    },
    width: {
      xs: "25px",
    },
    height: {
      xs: "25px",
    },
  },

  divider: {
    color: "#EAEAEA",
    width: "12vw",
    margin: "auto",
  },

  createdMainBox: {
    // mt: {
    //   xs: 2,
    //   md: 5,
    // },
  },

  createdTextBox: {
    display: { xs: "none", sm: "none", md: "flex" },
    justifyContent: "center",
    gap: { md: "10px" },
    p: 2,
    mt: {
      md: "-1px",
    },
  },

  createdTextBoxMob: {
    display: { xs: "flex", sm: "flex", md: "none" },
    justifyContent: "center",
    gap: "8px",
    flexDirection: "row",
    position: "fixed",
    top: { xs: "93%", sm: "92.9%" },
    margin: "auto",
    left: { xs: "35%", sm: "36%" },
  },

  createdByText: {
    fontSize: { xs: "15px", sm: "20px", md: "18px" },
    fontFamily: "Quicksand",
    color: "#393939",
    letterSpacing: "0px",
    fontWeight: 600,
    mt: { xs: 0.1, sm: -0.2, md: 0.3 },
  },

  konvergeLogo: {
    width: { xs: "23vw", sm: "14vw", md: "95px" },
    cursor: "pointer",
    position: "relative",
    top: { xs: "3px", md: "4px" },
  },

  bottomBox: {
    display: "flex",
    justifyContent: "center",
    marginTop: { xs: "20px", sm: "80px", md: 3 },
  },

  bottomText: {
    fontSize: { xs: "20px", md: "18px" },
    fontFamily: "Quicksand",
    color: "#393939",
    letterSpacing: "0px",
    fontWeight: 500,
    cursor: "pointer",
    "&: hover": {
      color: "#FD7E00",
    },
  },

  pipe: {
    fontSize: { xs: "27px", md: "20px" },
    ml: { xs: 1, md: 1 },
    mr: { xs: 1, md: 1 },
    mt: { xs: -0.8, md: 0 },
    color: "#393939",
  },

  iconsBox: {
    display: "flex",
    justifyContent: "center",
    mt: { xs: 3, sm: 5, md: 4 },
  },

  icons: {
    height: { xs: "30px", sm: "22px", md: "25px" },
    fontSize: { xs: "70px" },
    color: "gray",
    m: -2,
    cursor: "pointer",
    "&: hover": {
      color: "#FD7E00",
    },
  },

  textBox: {
    textAlign: {
      xs: "center",
      sm: "center",
      md: "center",
    },
    mt: {
      xs: 7,
      sm: 5,
    },
  },

  textField: {
    "& .MuiInputBase-input": {
      fontFamily: "Quicksand",
    },
    width: "100%",
    textAlign: {
      xs: "center",
      sm: "center",
      md: "center",
    },
    backgroundColor: "white",
    borderRadius: "10px",
    margin: "auto",
    zIndex: 10,
  },

  nearMeIcon: {
    background:
      "transparent url('img/paper-plane.png') 0% 0% no-repeat padding-box",
    opacity: 1,
  },

  loader: {
    display: "flex",
    position: "relative",
    top: { xs: "20px", md: "1%" },
    left: { xs: "20%", sm: "65%", md: "82%" },
    transform: "translate(-50%, -50%)",
  },

  footer: {
    display: { xs: "flex", sm: "flex", md: "none" },
    alignItems: "center",
    justifyContent: "center",
    padding: "39px",
    position: "relative",
    bottom: "15%",
    gap: "5px",
  },

  footerDiv: {
    position: "relative",
    top: { xs: "40px", md: "0" },
  },
};
